import { render, staticRenderFns } from "./PrimaryCareEmailModal.vue?vue&type=template&id=5d07931f"
import script from "./PrimaryCareEmailModal.vue?vue&type=script&lang=js"
export * from "./PrimaryCareEmailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports